import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { CircleButtonWithContent } from "./circleButtonWithContent";
import { ManageMyRepaymentModal } from "./manageMyRepaymentModal";
import { MANAGE_REPAYMENTS_INCREASE_ROUTE } from "../containers/IncreaseRepayments/route.constants";
import { RepaymentsIncrease } from "../../../components/icons";
import { INCREASE_PAYMENT_STATES } from "../../../constants/commonConstants";
import { useAccount } from "../../../hooks/client";
import { Wrapper } from "./manageMyRepaymentModal/manageMyRepaymentModal.styles";
import { TextButtonModal } from "./manageMyRepaymentModal/textButtonModal";
import { useTheme } from 'styled-components';
import environmentSettings from "@constants/environmentSettings";
import { useMagicBlocksAvailable } from "@utils/helpers/useMagicBlocksAvailable";

const ModalMessage = () => {
  const { phone, email } = environmentSettings;
  const showChatToUsOnlineButton = useMagicBlocksAvailable();

  const startChat = () => {
    document.getElementsByTagName('magicblocks-widget')[0].setAttribute('open', true)
  };

  return (
    <Wrapper>
      Please call&nbsp;<a href={`tel:${phone}`}>{phone}</a>&nbsp;or
      email&nbsp;<a href={`mailto:${email}`}>{email}</a>&nbsp;to
      discuss.
        {showChatToUsOnlineButton &&(<>
          &nbsp;Alternatively you can&nbsp;
          <TextButtonModal onClick={startChat}>
            chat to us online
          </TextButtonModal>
          .
        </>)}
    </Wrapper>
  );
};

export const IncreaseMyRepayments = ({ accountId }) => {
  const theme = useTheme();
  const { url } = useRouteMatch();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const { increaseRepayments } = useAccount(accountId) || {};

  const increaseRepaymentsUrl = url + MANAGE_REPAYMENTS_INCREASE_ROUTE.INCREASE + "?accountId=" + accountId;

  const increaseMyRepaymentsClicked = () => {
    switch (increaseRepayments) {
      case INCREASE_PAYMENT_STATES.SCHEDULE_LESS_THAN_TWO:
      case INCREASE_PAYMENT_STATES.SCHEDULE_MORE_THAN_TWO: {
        history.push(increaseRepaymentsUrl);
        break;
      }
      case INCREASE_PAYMENT_STATES.PAYMENT_ENDING:
      case INCREASE_PAYMENT_STATES.NO_PAYMENT:
      default: {
        setShowModal(true);
        break;
      }
    }
  };

  return (
    <>
      <CircleButtonWithContent variant="good" onClick={increaseMyRepaymentsClicked}>
        <RepaymentsIncrease themeColor={theme.palette.main.white} width="90px" />
        <span>Increase</span>
        <span>My Repayments</span>
      </CircleButtonWithContent>
      <ManageMyRepaymentModal visible={showModal} close={() => setShowModal(false)} header="Increase My Repayments" >
        <ModalMessage/>
      </ManageMyRepaymentModal>
    </>
  );
};